<template>
  <div id="billboard" class="div_card" style="padding: .75rem 1.25rem;">
    <div class="dataTables_scroll">
        <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
            <table style="margin:0.5em; width:100%;" cellspacing="0" >
                <thead>
                    <tr>
                        <th style="text-align: left; text-shadow: rgba(0, 0, 0, 0.2) 2px 6px 5px, rgba(255, 255, 255, 0.4) 0px -4px 30px;">{{$t('message.Anno_txt')}}</th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
            <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
                <tbody>
                    <tr v-for="(item,index) in docRecordList" :key="index" :index="'0'+index" :name="'N1'+index"
                          v-show="data1Len>0">
                        <td style="width:8.5em; padding:0.25em 0.5em; text-align:left; vertical-align: top;">
                          <i class="el-icon-time"></i>{{item.startDate | dateFormat}}<img src='@/assets/images/gif-new.gif' v-show="checkNewsTime(item.startDate)">
                        </td>
                        <td style="padding:0.25em 0.75em; text-align:left; vertical-align: top;">
                          <span v-html="item.content" v-if="1==item.newsType"></span>
                          <span v-else>{{item.content}}</span>
                          <span style="margin: 0 0.2rem;"
                            v-for="(f,index) in item.info"
                            :key="index"
                            :index="'0'+index"
                            :name="'F1'+index">
                            <a target="_blank"
                              :title="f.name"
                              :href="'./WebApi/Tools/GetAttach/'+f.rowId">
                              <img v-if="f.img1 != null" :src="f.img1" style="height:1.5em;" alt=""/>
                              <span v-else>
                                <img v-if="checkFileType(f.type) === 1" src="@/assets/images/word.gif" style="height:1.05em;" />
                                <img v-else-if="checkFileType(f.type) === 2" src="@/assets/images/image.gif" style="height:1.05em;"/>
                                <img v-else-if="checkFileType(f.type) === 3" src="@/assets/images/pdf.gif" style="height:1.05em;" />
                                <img v-else src="@/assets/images/attachment.png" style="height:1.05em;" />
                              </span>
                            </a>&nbsp;&nbsp;
                          </span>
                        </td>
                    </tr>
                    <tr v-show="0 == data1Len">
                        <td colspan="2" style="line-height:2.25em; text-align:left;">目前無公告~</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import * as tools from '../tool'
export default {
  name: 'billboard',
  data () {
    return {
      docRecordList: null,
      data1Len: 0
    }
  },
  methods: {
    checkNewsTime: function (startTime) {
      var date1 = new Date(startTime)
      var date2 = new Date()
      var timeDiff = Math.abs(date2.getTime() - date1.getTime())
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

      return (!(isNaN(diffDays) || (diffDays > 7)))
    },
    checkFileType: function (mimeType) {
      var ret = 0
      if (mimeType === 'application/msword' || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        ret = 1
      } else if (mimeType === 'image/jpeg') {
        ret = 2
      } else if (mimeType === 'application/pdf') {
        ret = 3
      }
      return ret
    }
  },
  filters: {
    dateFormat: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      return year + '/' + month + '/' + day
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.state.user
    }

  },
  created () {
    var vm = this
    var curDate = new Date()
    var tObj = {
      sysId: this.sysId,
      queryTime: [curDate.getFullYear(), curDate.getMonth() + 1, curDate.getDate()].join('-'),
      status: this.user.status
    }
    this.$http
      .put('./WebApi/Common/GetSystemNews/', tObj)
      .then(function (response) {
        vm.docRecordList = response.data
        vm.data1Len = 0
        if (!tools.isNull(vm.docRecordList)) {
          vm.data1Len = vm.docRecordList.length
        }
      })
      .catch(function (error) {
        tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
